import { axios, base } from '../http';

/** 开放平台概览统计 */
export const getOpenPlatformDashboard = () =>
  axios.get(`${base}/api/PartnerOpenDashboard/GetStats`);

/** 合作方应用分页 */
export const getPartnerOpenAppPage = (params) =>
  axios.get(`${base}/api/PartnerOpenApp/GetPage`, { params });

/** 可开通学校 */
export const getPartnerEligibleSchools = () =>
  axios.get(`${base}/api/PartnerOpenApp/GetEligibleSchools`);

/** 接入信息（不含 Secret） */
export const getPartnerAccessInfo = (id) =>
  axios.get(`${base}/api/PartnerOpenApp/GetAccessInfo`, { params: { id } });

/** 开通合作方 */
export const createPartnerOpenApp = (schoolDepartmentId) =>
  axios.post(`${base}/api/PartnerOpenApp/Create`, null, { params: { schoolDepartmentId } });

/** 重置密钥 */
export const resetPartnerOpenSecret = (id) =>
  axios.post(`${base}/api/PartnerOpenApp/ResetSecret`, null, { params: { id } });

/** 停用 */
export const disablePartnerOpenApp = (id) =>
  axios.post(`${base}/api/PartnerOpenApp/Disable`, null, { params: { id } });

/** 启用 */
export const enablePartnerOpenApp = (id) =>
  axios.post(`${base}/api/PartnerOpenApp/Enable`, null, { params: { id } });

/** 删除（软删除） */
export const deletePartnerOpenApp = (id) =>
  axios.post(`${base}/api/PartnerOpenApp/Delete`, null, { params: { id } });

/** 更新回调配置 */
export const updatePartnerCallback = (data) =>
  axios.post(`${base}/api/PartnerOpenApp/UpdateCallback`, data);

/** 更新开放资源范围。创建于 2026-08-26 */
export const updatePartnerOpenAppScopes = (data) =>
  axios.post(`${base}/api/PartnerOpenApp/UpdateScopes`, data);

/** 发送测试回调 */
export const sendPartnerTestCallback = (data) =>
  axios.post(`${base}/api/PartnerOpenApp/SendTestCallback`, data);

/** 获取学校天波/开放能力配置。创建于 2026-08-26 */
export const getSchoolTbConfig = (schoolDepartmentId) =>
  axios.get(`${base}/api/SchoolTbConfig/Get`, { params: { schoolDepartmentId } });

/** 保存学校天波/开放能力配置。创建于 2026-08-26 */
export const saveSchoolTbConfig = (data) =>
  axios.post(`${base}/api/SchoolTbConfig/Save`, data);

/** 接口访问日志分页 */
export const getPartnerAccessLogPage = (params) =>
  axios.get(`${base}/api/PartnerOpenAccessLog/GetPage`, { params });

/** 批量任务分页 */
export const getPartnerBatchPage = (params) =>
  axios.get(`${base}/api/PartnerOpenSyncTask/GetBatchPage`, { params });

/** 操作任务分页 */
export const getPartnerOperationPage = (params) =>
  axios.get(`${base}/api/PartnerOpenSyncTask/GetOperationPage`, { params });

/** 操作详情 */
export const getPartnerOperationDetail = (id) =>
  axios.get(`${base}/api/PartnerOpenSyncTask/GetOperationDetail`, { params: { id } });

/** 立即重试 */
export const retryPartnerOperationNow = (id) =>
  axios.post(`${base}/api/PartnerOpenSyncTask/RetryNow`, null, { params: { id } });

/** 人工处理 */
export const manualHandlePartnerOperation = (data) =>
  axios.post(`${base}/api/PartnerOpenSyncTask/ManualHandle`, data);

/** 回调 Inbox */
export const getPartnerCallbackInboxPage = (params) =>
  axios.get(`${base}/api/PartnerOpenCallbackLog/GetInboxPage`, { params });

/** 回调 Outbox */
export const getPartnerCallbackOutboxPage = (params) =>
  axios.get(`${base}/api/PartnerOpenCallbackLog/GetOutboxPage`, { params });

/** 重发 Outbox */
export const retryPartnerCallbackOutbox = (id) =>
  axios.post(`${base}/api/PartnerOpenCallbackLog/RetryOutbox`, null, { params: { id } });

/** 映射分页 */
export const getPartnerMappingPage = (params) =>
  axios.get(`${base}/api/PartnerOpenMapping/GetPage`, { params });

/** 修正天波 Id */
export const fixPartnerTbId = (data) =>
  axios.post(`${base}/api/PartnerOpenMapping/FixTbId`, data);
